import { createAction, props } from '@ngrx/store';
import { WorkflowFailedEmail } from './workflow-failed-email.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records workflow failed email'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records workflow failed email success', 
    props<{ listData: WorkflowFailedEmail[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records workflow failed email failure', 
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record workflow failed email',
    props<{ id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record workflow failed email success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record workflow failed email failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state workflow failed email',
);